export enum TimeCardStatusType {
  Open = "Open",           // set automatically when card created
  Closed = "Closed",       // set automatically when card clock out time set or by Admin from Approved
  Acknowledged = "Acknowledged", // set only by agent - transition allowed only from Closed
  Approved = "Approved",   // set only by admin - transition allowed only from Closed/Acknowledged
  Completed = "Completed", // transition allowed only by admin only and from Approved - final
  Archived = "Archived"   // transition allowed only by admin from Closed/Acknowledged - final, irreversible
}

// Translation key prefix for status labels: TIMECARD_SHIFT_STATUS.{status}
